import { FC } from 'react';
import { ILeftColumn } from '../../leftColumn.component';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PrintIcon from '@mui/icons-material/Print';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Theme as theme } from '../../../../../../styles/theme/theme';

export const StatusChips: FC<TStatusChips> = (props) => {
  const { orderType, isEmailServiceForInvoice } = props;
  const { t } = useTranslation();

  const isTypeDescription = orderType?.description && orderType?.color;
  const isEmailPropExist = typeof isEmailServiceForInvoice === 'boolean';
  return (
    <>
      {isTypeDescription && (
        <Chip label={orderType?.description} sx={{ backgroundColor: orderType?.color }} />
      )}
      {isEmailPropExist && (
        <>
          {isEmailServiceForInvoice ? (
            <Chip
              avatar={<MailOutlineIcon />}
              label={t('invoice.email_service')}
              sx={{ backgroundColor: theme.palette.grey[300] }}
            />
          ) : (
            <Chip
              avatar={<PrintIcon />}
              label={t('invoice.send_letter')}
              sx={{ backgroundColor: theme.palette.grey[300] }}
            />
          )}
        </>
      )}
    </>
  );
};

type TStatusChips = Pick<ILeftColumn, 'orderType' | 'isEmailServiceForInvoice'>;
